import { render } from "./AdminFavSuppListView.vue?vue&type=template&id=c3098106"
import script from "./AdminFavSuppListView.vue?vue&type=script&lang=js"
export * from "./AdminFavSuppListView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__